/**
 * @fileoverview added by tsickle
 * Generated from: util/types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var BinaryGender = {
    Female: "f",
    Male: "m",
};
export { BinaryGender };
/** @enum {string} */
var WorkerClassification = {
    Good: "good",
    Great: "great",
    Ineligible: "ineligible",
    Okay: "okay",
};
export { WorkerClassification };
/** @enum {string} */
var TravelPreference = {
    Bus: "bus",
    Train: "train",
    Cycle: "cycle",
    Car: "car",
};
export { TravelPreference };
/** @type {?} */
export var TRAVEL_PREFERENCE_OPTIONS = [
    { label: 'Bus', value: TravelPreference.Bus },
    { label: 'Train/Tube', value: TravelPreference.Train },
    { label: 'Cycle', value: TravelPreference.Cycle },
    { label: 'Car', value: TravelPreference.Car }
];
/**
 * @record
 */
export function LatLngLiteral() { }
if (false) {
    /** @type {?} */
    LatLngLiteral.prototype.lat;
    /** @type {?} */
    LatLngLiteral.prototype.lng;
}
/**
 * Represents the params that can be included in an API request supporting expandables.
 * @record
 */
export function ExpandableRequestParams() { }
if (false) {
    /** @type {?|undefined} */
    ExpandableRequestParams.prototype.expand;
    /** @type {?|undefined} */
    ExpandableRequestParams.prototype.only;
}
/**
 * Requests the params that can be included in an API request supporting rating token authentication.
 * @record
 */
export function TokenRequestParams() { }
if (false) {
    /** @type {?|undefined} */
    TokenRequestParams.prototype.token;
}
